import PropTypes from 'prop-types';
import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { joinCamp, leaveCamp } from '~/actions/camps'


class JoinCampButton extends React.Component {
    static propTypes = {
		ID: 			PropTypes.number.isRequired,
		status: 		PropTypes.string.isRequired,
		editing: 		PropTypes.bool,
		visibility: 	PropTypes.string.isRequired,
		feedLength: 	PropTypes.number.isRequired
	};

    state = {
        status: this.props.status
    };

    joinCamp = () => {
		this.props.joinCamp(this.props.ID, !this.props.feedLength)
		this.setState({
			status: this.props.visibility === 'public' ? 'joined' : 'requested'
		})
	};

    leaveCamp = () => {
		this.props.leaveCamp(this.props.ID)
		this.setState({
			status: 'not-joined'
		})
	};

    getJoinButton = () => {

		switch (this.state.status) {

			case 'admin':
				return <button className={"btn camp-button " + (this.props.editing ? 'bg-light-success text-white' : 'bg-white bg-slightly-transparent' )} onClick={this.props.toggleEditUsers}>
					{ this.props.editing ? 'Finish Editing' : 'Edit Users' }
				</button>

			case 'joined':
				return <button className="btn camp-button btn-danger" onClick={this.leaveCamp}>Leave Camp</button>

			case 'requested':
			case 'rejected':
				return <button className="btn camp-button btn-secondary" onClick={this.leaveCamp} disabled>Request Pending</button>

			case 'removed':
				return <button className="btn camp-button btn-primary" onClick={this.leaveCamp} disabled>Sorry, you can't join this camp</button>

			default: 
				return <button className="btn camp-button btn-primary" onClick={this.joinCamp}>
					{ this.props.visibility == 'public' ? 'Join Camp' : 'Request to Join' }
				</button>

		}
		
	};

    render() {

		return this.getJoinButton()

	}
}

const mapDispatchToProps = dispatch => bindActionCreators({ joinCamp, leaveCamp }, dispatch);

export default connect(
    null,
    mapDispatchToProps
)( JoinCampButton );




// WEBPACK FOOTER //
// ./src/js/views/Community/CampParts/HeaderParts/JoinCampButton.jsx